<template>
  <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit">
    <el-form-item label="Subject" prop="title">
      <el-input v-model="form.title" />
    </el-form-item>
    <el-form-item label="Countries" prop="countries">
      <el-select v-model="form.countries" name="country" multiple filterable placeholder="Limit to countries">
        <el-option v-for="(name, id) in $store.state.countries" :key="id" :label="name" :value="id" />
      </el-select>
    </el-form-item>
    <el-form-item label="Content" prop="content">
      <el-input id="mde" v-model="form.content" type="textarea" />
    </el-form-item>
    <el-button native-type="submit" type="primary" :loading="loading">
      Save
    </el-button>
  </el-form>
</template>

<script>
import moment from 'moment'
import SimpleMDE from 'simplemde'

export default {
  data() {
    return {
      loading: false,
      form: {
        content: this.newsletter.content,
        countries: this.newsletter.countries,
        title: this.newsletter.title,
      },
      rules: {
        'content': [
          { required: true, message: 'Content is required.', trigger: 'blur' },
        ],
        'title': [
          { required: true, message: 'Title is required.', trigger: 'blur' },
        ],
      },
    }
  },

  props: {
    newsletter: Object,
  },

  mounted() {
    var mde = new SimpleMDE({ element: document.getElementById('mde') })
    mde.codemirror.on('change', () => {
      this.form.content = mde.value()
    })
  },

  methods: {
    onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) return false

        this.loading = true

        try {
          var { data } = await this.$http.put(`/newsletters/${ this.newsletter.id }`, this.form)
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.$message.success('Newsletter has been updated.')
      })
    },
  },
}
</script>
